// extracted by mini-css-extract-plugin
export default {"listBlock":"list-block_listBlock__Xoeag","item":"list-block_item__Yfq+G","L":"list-block_L__f3yf+","M":"list-block_M__FJcKp","S":"list-block_S__e3srm"};